import { render, staticRenderFns } from "./PFLoanRejectReason.vue?vue&type=template&id=37a36d2e&scoped=true"
import script from "./PFLoanRejectReason.vue?vue&type=script&lang=js"
export * from "./PFLoanRejectReason.vue?vue&type=script&lang=js"
import style0 from "./PFLoanRejectReason.vue?vue&type=style&index=0&id=37a36d2e&prod&scoped=true&lang=css"
import style1 from "./PFLoanRejectReason.vue?vue&type=style&index=1&id=37a36d2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a36d2e",
  null
  
)

export default component.exports